export const blockIconsContentContentPaste = (
	<span className='material-symbols-outlined'>content_paste</span>
);
